webpackJsonp([81692003008797],{

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Main = __webpack_require__(17);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _CodeBlock = __webpack_require__(15);
	
	var _CodeBlock2 = _interopRequireDefault(_CodeBlock);
	
	var _DevHomework = __webpack_require__(12);
	
	var _DevHomework2 = _interopRequireDefault(_DevHomework);
	
	var _CodepenLink = __webpack_require__(27);
	
	var _CodepenLink2 = _interopRequireDefault(_CodepenLink);
	
	var _DownloadLink = __webpack_require__(16);
	
	var _DownloadLink2 = _interopRequireDefault(_DownloadLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tutorial = function Tutorial() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Named Lines'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In a previous example, we learned how to place an item on the grid by providing the ',
	      ' ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'grid-column'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'grid-row'
	      ),
	      ' properties with specific grid lines. We can also name some or all of those grid lines when defining a grid. This allows us to use those names instead of grid lines. To name a grid line, simply add the name in square brackets:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To name a grid line, we simply provide the name in square brackets:'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      null,
	      '\n.container {\n  display: grid;\n  width: 100%;\n  height: 600px;\n  grid-gap: 1rem;\n  grid-template-columns:\n    [main-start sidebar-start] 200px\n    [sidebar-end content-start] 1fr\n    [column3-start] 1fr\n    [content-end main-end];\n  grid-template-rows:\n    [row1-start] 80px\n    [row2-start] 1fr\n    [row3-start] 1fr\n    [row4-start] 100px\n    [row4-end];\n}\n      '
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Now that we have line names, we can use those names when placing items. Let\'s recreate our basic layout using named lines, instead of line numbers:'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      null,
	      '\n.header {\n  grid-column: main-start / main-end;\n  grid-row: row1-start / row2-start;\n}\n\n.sidebar {\n  grid-column: sidebar-start / sidebar-end;\n  grid-row: row2-start / row4-start;\n}\n\n.content-1 {\n  grid-column: content-start / content-end;\n  grid-row: row2-start / row3-start;\n}\n\n.content-2 {\n  grid-column: content-start / column3-start;\n  grid-row: row3-start / row4-start;\n}\n\n.content-3 {\n  grid-column: column3-start / content-end;\n  grid-row: row3-start / row4-start;\n}\n\n.footer {\n  grid-column: main-start / main-end;\n  grid-row: row4-start / row4-end;\n}\n      '
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Here is our HTML:'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      null,
	      '\n<div class="container">\n  <div class="item header">header</div>\n  <div class="item sidebar">sidebar</div>\n  <div class="item content-1">Content-1</div>\n  <div class="item content-2">Content-2</div>\n  <div class="item content-3">Content-3</div>\n  <div class="item footer">footer</div>\n</div>\n      '
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Here is the result:'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container-9' },
	      _react2.default.createElement(
	        'div',
	        { className: 'item header-9' },
	        'header'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'item sidebar-9' },
	        'sidebar'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'item content-1-9' },
	        'Content-1'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'item content-2-9' },
	        'Content-2'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'item content-3-9' },
	        'Content-3'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'item footer-9' },
	        'footer'
	      )
	    ),
	    _react2.default.createElement(_CodepenLink2.default, { link: 'https://codepen.io/mozilladevelopers/pen/dVpQVV' })
	  );
	};
	
	var Homework = function Homework() {
	  return _react2.default.createElement(
	    _DevHomework2.default,
	    { title: 'Firefox DevTools + CSS Grid Layout' },
	    _react2.default.createElement(
	      'p',
	      null,
	      'Did you know you can customize the color of the grid overlay in Firefox DevTools? The above example is on a white background, and the default purple may not be the best color to use. When selecting an overlay grid to display, you will see a circle next to the grid name that indicates the color of the overlay. Click on that circle, and you can customize the color to whatever you\'d like. Try a different color, such as red. Don\'t have Firefox?',
	      ' ',
	      _react2.default.createElement(
	        _DownloadLink2.default,
	        { content: 'cssgrid-page-9' },
	        'Download Firefox Developer Edition'
	      ),
	      '.'
	    )
	  );
	};
	
	exports.default = function () {
	  return _react2.default.createElement(_Main2.default, { currentPageNum: 9, tutorial: _react2.default.createElement(Tutorial, null), homework: _react2.default.createElement(Homework, null) });
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-css-grid-09-named-lines-js-e14a834fd64e2bae44bf.js